// @flow
import React, { Component, lazy, Suspense } from "react";

import ExpiresColorLabel from "../../components/licences/ExpiresColorLabel";
import {
  isMomentBefore,
  isMomentAfter,
  TodaytoEndTimeAppend
} from "../../../global/functions/DateTimeAmend";
import { LoadingProgress, NoItem } from "imagus-components";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Grid from "@material-ui/core/Grid";
import moment from "moment";

const LicenceItemRedux = lazy((): * =>
  import("../../containers/licences/LicenceItemRedux.js")
);

type LicenceListStatesType = {
  expanded: null | boolean
};

type LicenceListPropsType = {
  licences: Array<*>,
  isAdmin?: boolean,
  displayCompany?: boolean,
  isForUser?: boolean,
  canEdit?: boolean,
  openSnackbar?: Function,
  companyFilter?: Array<*>,
  dateStartFilter?: Date | null,
  dateEndFilter?: Date | null,
  licenceFilter?: string,
  statusFilter?: string,
  hostidFilter?: string
};

class LicenceList extends Component<
  LicenceListPropsType,
  LicenceListStatesType
> {
  constructor(props: LicenceListPropsType) {
    super(props);
    this.state = {
      expanded: null
    };
  }

  handleChange =
    (panel: *): * =>
      (e: Event, expanded: *): * => {
        this.setState({
          expanded: expanded ? panel : false
        });
      };

  isOneYearLicence = (licence: *): boolean => {
    if (licence.licenceType === "EVALUATION") {
      let start = moment(licence.startDate);
      let end = moment(licence.expiryDate);
      let different = end.diff(start, "days");
      return end.diff(start, "days") === 365;
    }
    return false;
  };

  render(): * {
    const { expanded } = this.state;
    const licences = this.props.licences;
    const list =
      licences &&
      licences.map((licence: *, i: number): * => {
        let display = true;
        if (this.props.companyFilter && this.props.companyFilter.length > 0) {
          if (this.props.companyFilter.indexOf(licence.company.id) < 0) {
            display = false;
          }
        }
        if (this.props.dateStartFilter) {
          if (
            isMomentBefore(licence.createDateOrigin, this.props.dateStartFilter)
          ) {
            display = false;
          }
        }
        if (this.props.dateEndFilter) {
          if (
            isMomentAfter(licence.createDateOrigin, this.props.dateEndFilter)
          ) {
            display = false;
          }
        }
        if (this.props.licenceFilter && this.props.licenceFilter !== "ALL") {
          if (licence.licenceType !== this.props.licenceFilter) {
            display = false;
          }
        }
        if (this.props.statusFilter && this.props.statusFilter !== "ALL") {
          if (this.props.statusFilter === "EXPIRED") {
            if (
              isMomentAfter(licence.expiryDateOrigin, TodaytoEndTimeAppend())
            ) {
              display = false;
            }
          }
          if (this.props.statusFilter === "ACTIVE") {
            if (
              isMomentBefore(licence.expiryDateOrigin, TodaytoEndTimeAppend())
            ) {
              display = false;
            }
          }
        }
        if (
          this.props.hostidFilter &&
          this.props.hostidFilter !== "" &&
          this.props.hostidFilter.length > 2
        ) {
          let stringFound = false;
          licence.devices.map((device: *, j: number): * => {
            if (device.hostId.includes(this.props.hostidFilter)) {
              stringFound = true;
            }
          });
          if (!stringFound) {
            display = false;
          }
        }

        //check for 1 year licence
        if (this.isOneYearLicence(licence)) {
          licence.licenceType = "ONEYEAR";
        }

        if (display) {
          return (
            <ExpansionPanel
              expanded={expanded === licence.id}
              onChange={this.handleChange(licence.id)}
              key={i}
            >
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle1" className="heading">
                  {licence.facebaseName}
                  <span className="green-label" style={{ marginLeft: "10px" }}>
                    {licence.licenceType}
                  </span>
                </Typography>
                {/* <Typography
                  variant="subtitle1"
                  className="subheading"
                ></Typography> */}
                <Typography variant="subtitle1" className="subheading">
                  <ExpiresColorLabel
                    expiryDate={licence.expiryDate}
                    expiryMinutes={licence.expiryMinutes}
                    title={true}
                  />
                </Typography>
                {this.props.displayCompany && (
                  <Typography variant="subtitle1" className="subheading">
                    {licence.company.name}
                  </Typography>
                )}
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <Suspense fallback={<LoadingProgress />}>
                  {expanded === licence.id && (
                    <LicenceItemRedux
                      licence={licence}
                      isAdmin={this.props.isAdmin}
                      displayCompany={this.props.displayCompany}
                      openSnackbar={this.props.openSnackbar}
                      isForUser={this.props.isForUser}
                      canEdit={this.props.canEdit}
                    />
                  )}
                </Suspense>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          );
        } else {
          return null;
        }
      });
    return (
      <div className="app-panel-content panel-top-margin">
        <Grid container spacing={24}>
          <Grid item xs={12}>
            {(list.filter((item: *): * => item !== null).length === 0 && (
              <NoItem content="No Licence has found." />
            )) ||
              list}
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default LicenceList;
